// components/OrderSummary.jsx - Functional Order Summary
import React from 'react';
import { Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { ROUTES } from '../../profileInfo/constant/Routes';
import WalletCreditDisplay from '../../../core-component/WalletCreditDisplay';

const OrderSummary = ({ user, translate, cart_items, cart_credit }) => {
  if (Object.keys(user).length === 0) {
    return null;
  }

  return (
    <div className='invoice rtl'>
      <div
        className='c-invoice-header'
        style={{
          backgroundColor: 'lightgrey',
          padding: '12px 16px',
          borderRadius: '8px',
          marginBottom: '16px',
          fontWeight: 'bold',
          color: '#01494b',
        }}
      >
        {translate('order-details')}
      </div>

      <div
        style={{
          marginBottom: '12px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingBottom: '8px',
          borderBottom: '1px solid #e0e0e0',
        }}
      >
        <Link
          to={ROUTES.CHARGING_WALLET}
          style={{
            fontSize: '14px',
            textDecoration: 'none',
            color: '#01494b',
          }}
        >
          {translate('credit')} (+افزایش اعتبار)
        </Link>
        <span style={{ fontSize: '12px' }}>
          <WalletCreditDisplay credit={cart_credit} />
        </span>
      </div>

      {cart_items.map((obj, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px 0',
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <h5 style={{ fontSize: '14px', margin: 0, fontWeight: '500' }}>{translate(obj.name)}</h5>
          <span style={{ fontSize: '12px' }}>{obj.render}</span>
        </div>
      ))}
    </div>
  );
};

export default OrderSummary;
